var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcWheelchairColored = function SvgIcWheelchairColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68D6AE",
    d: "m6.48 9.004 1.353-3.47a.33.33 0 0 1 .31-.213h1.94c.184 0 .334.15.334.334v4.258H7.093a.66.66 0 0 1-.613-.909"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.8,
    d: "M12.924 14.422v-4.175a.333.333 0 0 0-.333-.334h-2.174m0 0H7.093a.66.66 0 0 1-.613-.909l1.353-3.47a.33.33 0 0 1 .31-.213h1.94c.184 0 .334.15.334.334z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.215,
    cy: 2.911,
    r: 1.438,
    fill: "#68D6AE",
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M10.332 9.655q.112.448.113.93A3.838 3.838 0 1 1 7.184 6.79"
  })));
};
export default SvgIcWheelchairColored;